import React from "react";
import PropTypes from "prop-types";
import DigiFormItem from "./DigiFormItem";

class DigiFormCustomFieldsAnswers extends React.Component {
  state = {
    customFieldsAnswers: this.props.customFieldsAnswers
  };

  render() {
    const {
      customFieldsAnswers
    } = this.state;

    const {
      customFields,
      fieldErrors,
      onChange
    } = this.props;

    return (
      <div>
        {customFields && (customFields.map((customField, index) =>
          <DigiFormItem
            key={customField.unique_title}
            formFieldKey={customField.unique_title}
            customField={true}
            formField={{
              "type": customField.field_type,
              "label": customField.label,
              "value": customFieldsAnswers[customField.unique_title] || "",
              "select_options": customField.select_options || [],
              "required": customField.required,
              "enabled": true,
              "step": "any"
            }}
            fieldErrors={fieldErrors}
            onChange={this.handlerChangeField}
          />
        ))}
      </div>
    );
  }

  handlerChangeField = (newValue, key) => {
    const customFieldsAnswers = this.state.customFieldsAnswers;
    !(key in customFieldsAnswers) && (customFieldsAnswers[key] = {});
    customFieldsAnswers[key] = newValue;

    this.setState({ customFieldsAnswers: customFieldsAnswers, fieldErrors: {} });
    this.props.onChange(customFieldsAnswers, "answers");
  };

}

DigiFormCustomFieldsAnswers.propTypes = {
  customFields: PropTypes.array,
  customFieldsAnswers: PropTypes.object,
  fieldErrors: PropTypes.object,
  onChange: PropTypes.func
};

export default DigiFormCustomFieldsAnswers;
